import React from "react";
import CustomTable from "../../../commons/CustomTable";
import Action from "../../../commons/Action";
import moment from "moment";

const SalesTransactions = ({ sales_transactions, setIsId }) => {
  // Table Data
  const salesList = {
    data: sales_transactions,
  };

  // Table Heading
  const ColumnHeaders = () => {
    return (
      <>
        <th
          scope="col"
          className="px-5 py-3 table_responsive_text border-b font-semibold text-left bg-primary_shades_light whitespace-nowrap "
        >
          ID..{" "}
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Transaction Type
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Date
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Amount
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light "
        >
          Action
        </th>
      </>
    );
  };

  // Table Row
  const DataRows = () => {
    return (
      <>
        {(salesList?.data || [])?.map((element) => (
          <tr
            className={
              "border-b table_responsive_text hover:bg-secondary_light_shades"
            }
            key={element?.id}
          >
            {console.log(element)}
            <td className="px-5 py-3 truncate">{element?.id}</td>
            <td className="px-5 py-3 truncate capitalize">
              {element?.transaction?.payment_type.replace("_", " ")}
            </td>
            <td className="px-5 py-3 truncate">
              {moment(element?.created_at).format("DD MMM YYYY")}
            </td>
            <td className="px-5 py-3 truncate">${element?.amount}</td>
            <td className="px-5 py-3">
              <Action
                optionList={
                  <>
                    <li
                      className="flex gap-2 items-center lg:px-6 sm:px-5 px-4 lg:py-2 py-1 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                      onClick={() => {
                        setIsId(element?.id);
                      }}
                    >
                      View
                    </li>
                  </>
                }
              />
            </td>
          </tr>
        ))}
      </>
    );
  };

  return (
    <div className="w-full bg-white border rounded">
      <CustomTable
        columnHeaders={<ColumnHeaders />}
        dataRows={<DataRows />}
        data={salesList}
        overflowVisibleLg={false}
        // loader
        loading={false}
        showPagination={false}
        // // showLimit
        // setPaginationCurrentLimit={setPageLimit}
        // paginationCurrentLimit={pageLimit}
        // // paginationData
        // total={salesList?.total}
        // current={pageCount}
        // paginationData={(crPage) => setPageCount(crPage)}
      />
    </div>
  );
};

export default SalesTransactions;
